import {
    addNewRowToTable,
    convertUniversalDateTimeToPersianDateTime, DialogSize,
    Fancybox,
    RaikoBaseCardContainer,
    RaikoConfirmDialog,
    RaikoCustomTable,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoTableTitleContainer,
    showServerErrorMessage,
    showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {ProductImagesService} from "../../serverService/productImagesService/ProductImagesService";
import TableThumbnail from "../../component/tableCreateHelper/tableThumbnail/TableThumbnail";
import TableOtherAccessContainer
    from "../../component/tableCreateHelper/tableOtherAccessContainer/TableOtherAccessContainer";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import thumbnail from "../../assets/images/uploadImage.svg"
import AddNewProductImage from "./addNewProductImage/AddNewProductImage";
import "./ProductImages.scss"
import RaikoToggle from "../../raikoComponents/raikoToggle/RaikoToggle.tsx";

export default function ProductImages({productId}) {

    const [productImagesData, setProductImagesData] = useState([]);
    const service = new ProductImagesService();
    const [selectImageDialogState, setSelectImageDialogState] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const loading = new LoadingHelper(useLoadingDispatcher());
    const [deleteDialogState, setDeleteDialogState] = useState(false)
    const [selectedImageForDeleteId, setSelectedImageForDeleteId] = useState(-1);
    const [totalItems, setTotalItems] = useState(0);
    const [selectedItemId, setSelectedItemId] = useState(-1);


    useEffect(() => {
        if (typeof service !== 'undefined') {
            getProductImagesListFromServer()
        }
    }, [productId]);

    function handleUpdateProductImageEnabled(id, enabled) {
        loading.show()
        service.updateProductImageEnabled(id, enabled)
            .then(response => {
                const _productImages = productImagesData.find(item => item.id === id)

                const updatedItem = {..._productImages, enabled: enabled};

                const updatedList = productImagesData.map(item =>
                    item.id === id ? updatedItem : item
                );

                setProductImagesData(updatedList)

                // const _productImages = []
                //
                // setProductImagesData([])
                // productImagesData.map((item) =>
                //     _productImages.push(item.id === id ? {...item, enabled: enabled} : item)
                // )
                //
                //
                // setProductImagesData(_productImages)
                // console.log("is:", productImagesData)
                if (enabled) {
                    showSuccessMessage("انتشار تصویر با موفقیت انجام شد.")
                } else {
                    showWarningMessage("وضعیت انتشار تصویر به پیش نویس تغییر پیدا کرد.")
                }
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateProductImageMain(id, main) {
        loading.show()
        service.updateProductImageMain(id, main)
            .then(response => {
                const _productImages = productImagesData.find(item => item.id === id)

                const updatedItem = {..._productImages, main: true};
                const updatedList = productImagesData.map(item =>
                    item.id === id ? updatedItem : item
                );
                setProductImagesData(updatedList)
                if (main) {
                    showSuccessMessage("انتشار تصویر با موفقیت انجام شد.")
                } else {
                    showWarningMessage("وضعیت انتشار تصویر به پیش نویس تغییر پیدا کرد.")
                }
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }


    function productImageTableRowPreparation(number, id, url, productVariant, position, altText, enabled, main, createdAt, createdByAdmin) {
        return {
            number: number,
            id: id,
            image:
                <TableThumbnail
                    url={url}
                    caption={`بارگزاری شده در تاریخ ${convertUniversalDateTimeToPersianDateTime(createdAt)} توسط ${createdByAdmin}`}
                    alt={`بارگزاری شده در تاریخ ${convertUniversalDateTimeToPersianDateTime(createdAt)} توسط ${createdByAdmin}`}
                />
            ,
            productVariant: productVariant,
            position: position,
            altText: altText,
            productImageEnabled:
                <TableOtherAccessContainer>
                    <RaikoToggle
                        checked={enabled}
                        setChecked={_ => handleUpdateProductImageEnabled(id, !enabled)}
                        id={"status"}
                    />
                </TableOtherAccessContainer>,
            productImageMain: <TableOtherAccessContainer>
                <RaikoToggle
                    checked={main}
                    setChecked={_ => handleUpdateProductImageMain(id, !main)}
                    id={"main"}
                />
            </TableOtherAccessContainer>,
            access:
                <TableOtherAccessContainer>
                    <div className={"icTrash"} onClick={_ => {
                        handleDeleteProductImage(id)
                    }}/>
                </TableOtherAccessContainer>
        }
    }


    function getProductImagesListFromServer() {
        setTableLoading(true)
        service.getProductImagesList(productId)
            .then(response => {
                setProductImagesData([])
                response.map((item, index) => {
                    setProductImagesData(prevState => [
                        ...prevState,
                        productImageTableRowPreparation(
                            index + 1,
                            item.id,
                            item.file.url,
                            item.variant.title,
                            item.position,
                            item.altText,
                            item.enabled,
                            item.main
                        )
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    function handleDeleteProductImage() {
        loading.show()
        service.deleteProductImage(selectedImageForDeleteId)
            .then(response => {
                showSuccessMessage("حذف تصویر با موفقیت انجام شد.")
                setDeleteDialogState(false)
                getProductImagesListFromServer()
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }


    function handleCloseSelectImageDialog() {
        setSelectImageDialogState(false)
        setTimeout(() => {
            setSelectedItemId(-1)
        }, 1000);
    }

    function handleOpenSelectImageDialog() {
        setSelectImageDialogState(true)
    }

    function addNewProductImageToTable(item) {
        const _items = addNewRowToTable(
            productImageTableRowPreparation(
                1,
                item.id,
                item.file.url,
                item.variant.title,
                item.position,
                item.altText,
                item.enabled,
                item.main
            ),
            productImagesData
        );
        setProductImagesData(_items)
    }

    function handleShowProductImageDetails(id) {
        setSelectedItemId(id)
        setSelectImageDialogState(true)
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseSelectImageDialog}
                open={selectImageDialogState}
                dialogSize={DialogSize.LARG}
                hasCloseButton={false}
            >
                <AddNewProductImage
                    productId={productId}
                    selectedItemId={selectedItemId}
                    handleCloseSelectImageDialog={handleCloseSelectImageDialog}
                    handleAddNewProductImage={addNewProductImageToTable}
                />
            </RaikoDefaultDialogPage>
            <RaikoConfirmDialog
                openConfirmDialog={deleteDialogState}
                cancelAction={_ => {
                    setDeleteDialogState(false)
                }}
                doAction={handleDeleteProductImage}
                warningDescription={""}
                pageTitle={"حذف تصویر"}
            />
            <RaikoBaseCardContainer>
                <RaikoGridOneColumn>
                    <RaikoTableTitleContainer
                        title={"اسلایدر محصولات"}
                        amount={totalItems}
                        hasCreateNewItem
                        handleCreateNewItem={handleOpenSelectImageDialog}
                    />
                    <RaikoGridOneColumn>
                        {
                            productImagesData && productImagesData.length > 0 ?
                                <RaikoGridOneColumn className={"fancyboxContainer"}>
                                    <Fancybox
                                        options={{
                                            Carousel: {
                                                infinite: false,
                                            },
                                        }}
                                    >
                                        <RaikoCustomTable
                                            header={productImagesHeader}
                                            data={productImagesData}
                                            isLoading={tableLoading}
                                            rowClicked={handleShowProductImageDetails}
                                        />
                                    </Fancybox>
                                </RaikoGridOneColumn>
                                :
                                <RaikoGridOneColumn className={"emptyListStateContainer"}>
                                    <img src={thumbnail} alt=""/>
                                    <span>با کلیک بر روی افزودن اولین تصویر خود را اضافه نمایید !!</span>
                                </RaikoGridOneColumn>
                        }
                    </RaikoGridOneColumn>
                </RaikoGridOneColumn>


            </RaikoBaseCardContainer>
        </>
    )
}
const productImagesHeader = [
    {
        id: 'number',
        label: '#'
    },
    {
        id: 'image',
        label: 'تصویر'
    },
    {
        id: 'productVariant',
        label: 'نوع محصول'
    },
    {
        id: 'position',
        label: 'اولویت'
    },
    {
        id: 'altText',
        label: 'متن جایگزین'
    },
    {
        id: 'productImageEnabled',
        label: 'وضعیت'
    },
    {
        id: 'productImageMain',
        label: 'تصویر پیش فرض'
    },
    {
        id: 'access',
        label: 'دسترسی ها'
    },
]